var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPluseIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons 18/18px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Add Icon",
    d: "M15.154 8.12487H9.87513V2.84598C9.86744 2.61901 9.77187 2.40391 9.60859 2.24607C9.44531 2.08823 9.2271 2 9 2C8.7729 2 8.55469 2.08823 8.39141 2.24607C8.22813 2.40391 8.13256 2.61901 8.12487 2.84598V8.12487H2.84598C2.61901 8.13256 2.40391 8.22813 2.24607 8.39141C2.08823 8.55469 2 8.7729 2 9C2 9.2271 2.08823 9.44531 2.24607 9.60859C2.40391 9.77187 2.61901 9.86744 2.84598 9.87513H8.12487V15.154C8.13256 15.381 8.22813 15.5961 8.39141 15.7539C8.55469 15.9118 8.7729 16 9 16C9.2271 16 9.44531 15.9118 9.60859 15.7539C9.77187 15.5961 9.86744 15.381 9.87513 15.154V9.87513H15.154C15.381 9.86744 15.5961 9.77187 15.7539 9.60859C15.9118 9.44531 16 9.2271 16 9C16 8.7729 15.9118 8.55469 15.7539 8.39141C15.5961 8.22813 15.381 8.13256 15.154 8.12487Z",
    fill: "#00C851"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPluseIcon);
export default __webpack_public_path__ + "static/media/pluseIcon.d3bb88aa222ee67bff988746194030ab.svg";
export { ForwardRef as ReactComponent };